import React from "react";

const Spinner = () => {
  const loadingContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // Full screen height
  };

  const spinnerStyle = {
    width: "40px",
    height: "40px",
    border: "4px solid #3498db", // Blue ring all around
    borderColor: "#3498db transparent #3498db transparent", // Alternating colors for effect
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  const keyframesStyle = `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }`;

  return (
    <>
      <div style={loadingContainerStyle}>
        <div style={spinnerStyle} />
      </div>
      <style>{keyframesStyle}</style>
    </>
  );
};

export default Spinner;
